import React from 'react';
import useTestimonials from '../hooks/useTestimonials';
import './Testimonials.css';

const Testimonials = ({ cursoId }) => {
  const { testimonials, loading, error } = useTestimonials(cursoId);

  if (loading) return <div className="testimonials-loading">Cargando testimonios...</div>;
  if (error) return <div className="testimonials-error">Error al cargar testimonios</div>;

  if (testimonials.length === 0) {
    return (
      <div className="testimonials-container">
        <h3>Lo que dicen nuestros alumnos</h3>
        <p className="no-testimonials">No hay testimonios aún.</p>
      </div>
    );
  }

  return (
    <div className="testimonials-container">
      <h3>Lo que dicen nuestros alumnos</h3>
      <div className="testimonials-grid">
        {testimonials.map((testimonio) => (
          <div key={testimonio._id} className="testimonial-card">
            <p className="testimonial-text">"{testimonio.text}"</p>
            <div className="testimonial-footer">
              <span className="testimonial-author">{testimonio.author}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Testimonials;
